module.exports = __webpack_public_path__ + "static/media/blue-illustration.60105456.jpg";